export default function AddIcon({
  color = "currentColor",
}: {
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M0.8125 7H13.1875M7 0.8125V13.1875"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
